import React from "react";
import { LegacyCard as Card } from "@shopify/polaris";
import PropTypes from "prop-types";

// helper components
import { DropZone } from "lib/components";

const Image = (props) => {
  const { onChange, variantImage = [], cms } = props;

  return (
    <Card title={cms("section.images.title")} sectioned>
      <DropZone
        id="dropZone"
        onAdd={(value) => onChange(value)}
        onRemove={() => onChange([])}
        fileList={variantImage}
        size={10}
      />
    </Card>
  );
};

Image.propTypes = {
  cms: PropTypes.func.isRequired,
  variantImage: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

Image.defaultProps = {
  variantImage: [],
};

export default Image;
